(function($, Drupal, drupalSettings) {

  Drupal.behaviors.account_button = {
    attach: function (context, settings) {
      if (!$('body').hasClass('user-logged-in')) {
        $('.account-button').click(function (event) {
          event.preventDefault();

          if (!$('body').hasClass('page--user-login-form') &&
            !$('body').hasClass('.page--user--password')) {
            $('.Login-popup-link a').trigger('click');
            $('body').removeClass('login-form--datasheet');
          }

        });

        $('body').on('click', '.ui-widget-overlay', function() {
          $('.ui-dialog-titlebar-close').trigger('click');
        });

      }

      $('.datasheet-nolink').click(function() {
        $('.Login-popup-link a').trigger('click');
        $('body').addClass('login-form--datasheet');
      });

    }
  }; // Drupal.behaviors.account_button

})(jQuery, Drupal, drupalSettings);
